import script from "./LanguageChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageChoice.vue?vue&type=script&setup=true&lang=js"

import "./LanguageChoice.vue?vue&type=style&index=0&id=42c638ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c638ca"]])

export default __exports__